import apis from '../../utils/apis';
import { AppDispatch } from '../index';

export const loadTourCompletions = (completions: Record<string, string>) => ({
  type: 'LOAD_TOUR_COMPLETIONS' as const,
  payload: completions,
});

export const completeTour = (tourId: string) => async (dispatch: AppDispatch) => {
  try {
    const response = await apis.post('/tour-status/complete', { tour_id: tourId });
    if (response.data.success) {
      dispatch({
        type: 'TOUR_COMPLETED' as const,
        payload: { tourId, completions: response.data.tour_completions },
      });
    }
  } catch {
    // Non-critical — tour will just show again next time
  }
};

export const resetTourCompletion = (tourId: string) => async (dispatch: AppDispatch) => {
  try {
    const response = await apis.post('/tour-status/reset', { tour_id: tourId });
    if (response.data.success) {
      dispatch({
        type: 'TOUR_RESET' as const,
        payload: { tourId, completions: response.data.tour_completions },
      });
    }
  } catch {
    // Non-critical
  }
};

export const resetAllTours = () => async (dispatch: AppDispatch) => {
  try {
    const response = await apis.post('/tour-status/reset-all');
    if (response.data.success) {
      dispatch({ type: 'TOURS_RESET_ALL' as const });
    }
  } catch {
    // Non-critical
  }
};
